import type { FontVariant } from "./types";

type FontCatalogItem = {
    family: string;
    slug: string;
    variants?: FontVariant[];
};

export const FONT_CATALOG: FontCatalogItem[] = [
    { family: "Arial", slug: "arial" },
    { family: "Bitter", slug: "bitter" },
    { family: "Caveat", slug: "caveat", variants: ["regular", "bold"] },
    { family: "Comfortaa", slug: "comfortaa", variants: ["regular", "bold"] },
    { family: "EB Garamond", slug: "eb-garamond" },
    { family: "Georgia", slug: "georgia" },
    { family: "Inter", slug: "inter" },
    { family: "Literata", slug: "literata" },
    { family: "Lobster", slug: "lobster", variants: ["regular"] },
    { family: "Montserrat", slug: "montserrat" },
    { family: "Noto Sans", slug: "noto-sans" },
    { family: "Noto Serif", slug: "noto-serif" },
    { family: "Nunito", slug: "nunito" },
    {
        family: "Open Sans",
        slug: "open-sans",
        variants: ["regular", "bold", "italic", "bold-italic"],
    },
    { family: "Open Sans Condensed", slug: "open-sans-condensed" },
    { family: "Oranienbaum", slug: "oranienbaum", variants: ["regular"] },
    { family: "Oswald", slug: "oswald", variants: ["regular", "bold"] },
    { family: "Pacifico", slug: "pacifico", variants: ["regular"] },
    { family: "Playfair Display", slug: "playfair-display" },
    { family: "Playpen Sans", slug: "playpen-sans", variants: ["regular", "bold"] },
    { family: "PT Sans", slug: "pt-sans" },
    { family: "Raleway", slug: "raleway" },
    { family: "Roboto", slug: "roboto" },
    { family: "Roboto Condensed", slug: "roboto-condensed" },
    { family: "Roboto Flex", slug: "roboto-flex", variants: ["regular"] },
    { family: "Roboto Slab", slug: "roboto-slab", variants: ["regular", "bold"] },
    { family: "Rubik", slug: "rubik" },
    { family: "Source Sans 3", slug: "source-sans-3" },
    { family: "Source Serif 4", slug: "source-serif-4" },
    { family: "Times New Roman", slug: "times-new-roman" },
    { family: "Zen Old Mincho", slug: "zen-old-mincho", variants: ["regular", "bold"] },
];

export const FONT_FAMILIES = FONT_CATALOG.map(({ family }) => family);
export const FONT_FAMILY_SET = new Set(FONT_FAMILIES);

const DEFAULT_FONT_VARIANTS: FontVariant[] = ["regular", "bold", "italic"];

export const getFontVariants = (fontFamily: string): readonly FontVariant[] => {
    const item = FONT_CATALOG.find((font) => font.family === fontFamily);
    return item?.variants ?? DEFAULT_FONT_VARIANTS;
};

export const hasFontVariant = (fontFamily: string, variant: FontVariant): boolean => {
    return getFontVariants(fontFamily).includes(variant);
};
